var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.45,
    height: 24.56,
    viewBox: "0 0 26.45 24.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star",
    "data-name": "Icon ionic-ios-star",
    d: "M27.7,11.877H19.011L16.372,4a.956.956,0,0,0-1.795,0l-2.639,7.876H3.195a.947.947,0,0,0-.945.945.694.694,0,0,0,.018.159.908.908,0,0,0,.4.667L9.8,18.678,7.062,26.642a.947.947,0,0,0,.325,1.063.914.914,0,0,0,.531.23,1.157,1.157,0,0,0,.59-.213l6.967-4.965,6.967,4.965a1.106,1.106,0,0,0,.59.213.848.848,0,0,0,.525-.23.936.936,0,0,0,.325-1.063l-2.739-7.964L28.221,13.6l.171-.148a.99.99,0,0,0,.307-.632A1,1,0,0,0,27.7,11.877Z",
    transform: "translate(-2.25 -3.375)",
    fill: "#ffad0a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigStart);
export default __webpack_public_path__ + "static/media/big-start.2addc3d75f4cc5f1e2add1efacf050a6.svg";
export { ForwardRef as ReactComponent };